import React from 'react';
import { ChevronRightIcon } from '@heroicons/react/24/outline';

function UserMenuItem({
  icon: Icon,
  label,
  onClick,
  danger = false,
}) {
  return (
    <button
      className={`mp-user-menu__item ${danger ? 'mp-user-menu__item--danger' : ''}`}
      onClick={onClick}
      type="button"
    >
      <span className="mp-user-menu__item-rail" aria-hidden="true" />

      <span className="mp-user-menu__item-icon-wrap" aria-hidden="true">
        <Icon className="mp-user-menu__item-icon" />
      </span>

      <span className="mp-user-menu__item-label">{label}</span>

      <ChevronRightIcon className="mp-user-menu__item-arrow" aria-hidden="true" />
    </button>
  );
}

export default UserMenuItem;